import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "Initialize_Error" }
const _hoisted_3 = {
  key: 2,
  class: "px-10"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "textCenter-h" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "textPrimaryTitle" }, "Proceso de habilitación"),
  /*#__PURE__*/_createElementVNode("p", { class: "textPrimaryParagraph" }, "Nos estamos renovando para brindarte una experiencia única y para lograrlo nuestro aliado ha cambiado."),
  /*#__PURE__*/_createElementVNode("p", { class: "textPrimaryParagraph pb-4" }, "No te preocupes, esto no afectará ninguna de las funcionalidades de nuestro portal, sin embargo, es necesario que realices el proceso de habilitación ante la DIAN y asi continuar disfrutando de nuestros servicios.")
], -1)
const _hoisted_5 = { class: "textCenter-h d-flex align-items-center h-100" }
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  id: "video",
  class: "QualificationDelcop_video_player",
  controls: ""
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "textPrimaryParagraph textBold textLeft mt-0 pl-4" }
const _hoisted_11 = { class: "textCenter-h px-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "textPrimaryTitle" }, "Código habilitación", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_InitialDelcop = _resolveComponent("InitialDelcop")!
  const _component_ProcessDelcop = _resolveComponent("ProcessDelcop")!
  const _component_ApprovedDelcop = _resolveComponent("ApprovedDelcop")!
  const _component_RejectedDelcop = _resolveComponent("RejectedDelcop")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_PopUpTerminosCondiciones = _resolveComponent("PopUpTerminosCondiciones")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.errorResponse !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString($setup.errorResponse), 1)
        ]))
      : _createCommentVNode("", true),
    ($setup.spinnerView)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 1,
          type: "modern"
        }))
      : _createCommentVNode("", true),
    (!$setup.spinnerView && $setup.errorResponse === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 12,
                xl: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      ($setup.urlvd != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("video", _hoisted_8, [
                              _createElementVNode("source", {
                                src: $setup.urlvd,
                                type: "video/mp4"
                              }, null, 8, _hoisted_9)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_10, [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.Download()))
                        }, "Descarga aquí"),
                        _createTextVNode(" el instructivo de habilitación")
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 12,
                xl: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    ($setup.stateHabilitacion != '')
                      ? (_openBlock(), _createBlock(_component_el_card, {
                          key: 0,
                          shadow: "always",
                          class: "rounded-card"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            ($setup.stateHabilitacion == 'Inicial')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_InitialDelcop, { onOnFireDelcop: $setup.changeState }, null, 8, ["onOnFireDelcop"])
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.stateHabilitacion == 'EnProceso' || $setup.stateHabilitacion == 'ErrorTercero')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_ProcessDelcop)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.stateHabilitacion == 'Aprobado')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_ApprovedDelcop)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.stateHabilitacion == 'Rechazado')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createVNode(_component_RejectedDelcop, { onOnFireDelcop: $setup.changeState }, null, 8, ["onOnFireDelcop"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    ($setup.mostrarPopUpTerminosCondiciones)
      ? (_openBlock(), _createBlock(_component_PopUpTerminosCondiciones, {
          key: 3,
          textoPopUpTYC: $setup.textoPopUpTYC,
          siguientePaginaTYC: $setup.siguientePaginaTYC,
          nombreBotonConfirmTYC: $setup.nombreBotonConfirmTYC,
          paginaOrigen: $setup.paginaOrigen,
          StoreVacio: $setup.StoreVacio,
          onCerrarPopUpTYC: $setup.cerrarPopUpTYC
        }, null, 8, ["textoPopUpTYC", "siguientePaginaTYC", "nombreBotonConfirmTYC", "paginaOrigen", "StoreVacio", "onCerrarPopUpTYC"]))
      : _createCommentVNode("", true)
  ], 64))
}